import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { authEnabled } from '@/config';
import { RETURN_TO_KEY } from '@/auth/RequireAuth';

// Lands here from the Hosted UI redirect. react-oidc-context exchanges the
// code automatically (the URL matches redirect_uri); once the user exists,
// bounce to wherever the visit originally pointed.
function CallbackInner() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isLoading) return;
    const returnTo = sessionStorage.getItem(RETURN_TO_KEY) || '/';
    sessionStorage.removeItem(RETURN_TO_KEY);
    navigate(returnTo, { replace: true });
  }, [auth.isLoading, navigate]);

  if (auth.error) {
    return <div className="auth-screen">Sign-in failed: {auth.error.message}</div>;
  }
  return <div className="auth-screen">Signing you in…</div>;
}

export default function CallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!authEnabled) navigate('/', { replace: true });
  }, [navigate]);

  if (!authEnabled) return null;
  return <CallbackInner />;
}
